import { motion } from "framer-motion";
import { Heart, Zap, Shield, Users } from "lucide-react";

const stats = [
  { number: "200+", label: "Khách hàng", icon: Users },
  { number: "99%", label: "Hài lòng", icon: Heart },
  { number: "24h", label: "Giao hàng", icon: Zap },
  { number: "24/7", label: "Hỗ trợ", icon: Shield },
];

const Sectionvalue: React.FC = () => {
  return (
    <section className="overflow-hidden bg-white py-12 md:py-16">
      <div className="container mx-auto px-4">
        <div className="mx-auto grid max-w-[1120px] grid-cols-2 gap-4 sm:gap-5 lg:grid-cols-4 lg:gap-6">
          {stats.map((stat, index) => {
            const Icon = stat.icon;

            return (
              <motion.div
                key={stat.label}
                className="rounded-[22px] border border-red-100 bg-[linear-gradient(180deg,#ffffff_0%,#fff7f7_100%)] px-4 py-5 text-center shadow-[0_14px_34px_rgba(127,29,29,0.05)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_18px_42px_rgba(127,29,29,0.08)] sm:px-5 sm:py-6"
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.45, delay: index * 0.08 }}
                viewport={{ once: true }}
              >
                <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-2xl border border-red-100 bg-white text-red-500 shadow-[0_10px_24px_rgba(220,38,38,0.10)] sm:h-14 sm:w-14">
                  <Icon size={26}  />
                </div>

                <h3 className="text-[28px] font-semibold leading-none text-[#2f1a1a] sm:text-[32px]">
                  {stat.number}
                </h3>

                <p className="mt-2 text-[13px] font-medium tracking-[0.04em] text-slate-600 sm:text-[14px]">
                  {stat.label}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Sectionvalue;
